import React from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import useEnvironment from '../../../../../hooks/location/useEnviroment'
import type { PractitionerRole } from '@teschglobal/tg-fhir-react-components/dist/types'
import type { ProviderResponse } from '../../../../../types/FHIRTypes/ProviderResponse'
import FhirLoader from '../../../../FhirLoader'
import { PractitionerRoleTable } from '@teschglobal/tg-fhir-react-components'

type PractitionerRoleListProps = {
  practitionersRole: ProviderResponse<PractitionerRole>
  clickViewDataLink: (practitionerRole: PractitionerRole) => void
  isFetching: boolean
  isLoading: boolean
  isSuccess: boolean
  totalPages: number
  currentPage: number
  handleChangePage: (page: number) => void
}

const PractitionerRoleList: React.FC<PractitionerRoleListProps> = ({
  practitionersRole,
  clickViewDataLink,
  isFetching,
  isLoading,
  isSuccess,
  totalPages,
  currentPage,
  handleChangePage,
}) => {
  const { data: environment } = useEnvironment()

  const rows: PractitionerRole[] = practitionersRole?.data ?? []

  return (
    <>
      <h3>PractitionerRole</h3>

      {isLoading || isFetching ? (
        <FhirLoader message="Loading..." />
      ) : (
        <>
          {practitionersRole?.total > 0 && environment?.includeTotalInFHIRRequest && (
            <div className="my-3 fw-bold">
              <span role="status" aria-live="polite">
                {practitionersRole.total.toLocaleString()} record(s) found
              </span>
              <PaginationButtons
                totalPages={totalPages}
                currentPage={currentPage}
                handleChangePage={handleChangePage}
              />
            </div>
          )}

          <PractitionerRoleTable
            practitionerRoles={rows}
            onRowLinkClick={clickViewDataLink}
          />

          {practitionersRole?.total > 0 && environment?.includeTotalInFHIRRequest && (
            <div className="my-3 fw-bold">
              <PaginationButtons
                totalPages={totalPages}
                currentPage={currentPage}
                handleChangePage={handleChangePage}
              />
            </div>
          )}
        </>
      )}
    </>
  )
}

export default PractitionerRoleList
